




















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import DropdownCompareHatchery from '@/components/poultry/DropdownCompareHatchery.vue';
import DropdownCompare from '@/components/poultry/DropdownCompare.vue';
import Dropdown from '@/components/poultry/Dropdown.vue';
import DropdownFilter from '@/components/poultry/DropdownFilter.vue';
import DropdownFilterSearchBar from '@/components/poultry/DropdownFilterSearchBar.vue';
import { dropdownStores } from '@/store/poultry/dropdowns';
import { Region } from '@/models/poultry/country.model';
import { clientStores } from '@/store/poultry/client/index';
import { ClientResponse } from '@/models/poultry/client.model';
import { auditorStores } from '@/store/poultry/auditor/index';
import { AuditorResponse } from '@/models/poultry/auditor.model';
import VueMonthlyPicker from 'vue-monthly-picker';
import { analysisStores } from '@/store/poultry/analysis/index';
import ClientNameFilter from '@/views/poultry/Reports/ReportTableFilter/ClientNameFilter.vue';
import { reportStores } from '@/store/poultry/report/index';
import moment from 'moment'; // TODO: Need to use moment as the Month Picker use moment lib
import DropdownFilterAlt from '@/components/poultry/DropdownFilterAlt.vue';
import { DropdownOption } from '@/models/poultry/dropdown.model';
import { reportTypeStores } from '@/store/poultry/reportType';
import { ReportTypeIds } from '../../../../constants';

@Component({
  components: {
    DropdownCompare,
    DropdownCompareHatchery,
    DropdownFilter,
    DropdownFilterAlt,
    DropdownFilterSearchBar,
    ClientNameFilter,
    Dropdown,
    VueMonthlyPicker,
  },
})
export default class SectionAnalysisPageHeader extends Vue {
  defaultFormat = 'MM/YYYY';
  monthList = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  clientStore = clientStores.list;
  clientDetailStore = clientStores.details;
  auditorStore = auditorStores.list;
  auditorDetailStore = auditorStores.details;
  countryStore = dropdownStores.country;
  analysisStore = analysisStores.hatchery.list;
  reportStore = reportStores.list;
  reportTypeDetailStore = reportTypeStores.detail;
  isBetweenComplexes = false;
  isSectionTypeSelected = false;
  defaultFilterType = 'state';
  defaultAnalysisType = 'between_clients';
  clientNameData: Object[] = [];
  // Init type for ref
  $refs!: {
    resetSelectedData: HTMLFormElement;
    activeSelectedDropdown: any;
  };

  section: any = {
    sectionType: null,
    clientIds: [],
    categoryType: null,
    filteredData: [],
    fromMonth: null,
    toMonth: null,
  };

  // This one would be a fixed valueextra: 
  hatcherySectionData = [
    { text: 'Select a section', value: '' },
    { text: 'Vaccine And Storage', value: 'vaccine_and_storage' },
    { text: 'Preparation', value: 'preparation' },
    { text: 'Vaccination Process', value: 'vaccination_process' },
    { text: 'Post Vaccination', value: 'post_vaccination_steps' },
  ];

  // This one would be a fixed value
  categoryType = [
    { text: 'State', value: 'state' },
    { text: 'Auditor', value: 'auditor' },
  ];

  // Init data in all store by fetchAll
  async created() {
    const species = (this.$router.currentRoute.fullPath.split('/'))[1];

    this.clientStore.setSpecies(species)
    await this.clientStore.fetchClients();
    await this.countryStore.fetchCountries();
    await this.countryStore.fetchStatesByCountryCode();
    this.clientNameData = this.clientsName;
  }

  get minMonth() {
    if (this.section.fromMonth) {
      const oneMonthAfter = moment(this.section.fromMonth).add(1, 'months');
      return oneMonthAfter;
    }

    return moment(new Date()).add(1, 'months')
  }

  get maxMonth() {
    if (this.section.fromMonth) {
      const oneYear = moment(this.section.fromMonth).add(11, 'months');
      return oneYear;
    }

    return moment(new Date()).add(11, 'months');
  }

  @Watch('section.fromMonth')
  clearMaxMonth() {
    if (this.section.fromMonth) {
      this.section.toMonth = null;
    }
  }

  get isCategoryTypeSelected() {
    return !this.section.categoryType;
  }

  get disableDropdown() {
    return !this.section.clientIds.length;
  }

  // To get list of clients in dropdown filter
  get clients(): ClientResponse[] {
    return this.clientStore.clientsDropdown;
  }

  async searchByClientName(inputClientName: any) {
    // Filter the Client Objects here.
    if (!inputClientName.trim()) {
      this.clientNameData = this.clientsName;
    } else {
      await this.clientStore.searchByKeywords({
        keywords: inputClientName
      });

      this.clientNameData = this.clientStore.clients.map(client => {
        return {
          text: client.name,
          value: String(client.id)
        };
      });

    }
  }

  get clientsName() {
    return Object.values(this.clients).map((client) => {
      return {
        text: client.name,
        value: String(client.id),
      };
    });
  }

  // To get list of states in dropdown filter
  get regions(): Region[] {
    return this.countryStore.regions;
  }

  get regionsName() {
    return Object.values(this.regions).map(({ name, id}: any) => {
      return {
        text: name,
        value: id,
      };
    });
  }

  // To get list of auditors in dropdown filter
  get auditors(): AuditorResponse[] {
    return this.auditorDetailStore.auditorsDropdown;
  }

  get auditorsName() {
    return this.auditors.map((auditor) => {
      return {
        text: auditor.userProfile.name,
        value: String(auditor.id),
      };
    });
  }

  // This watcher is to reset value in category and selection
  @Watch('analysisStore.clientName')
  clearCategoryAndSelections() {
    this.section.categoryType = null;
    this.$refs.resetSelectedData['selectedData'] = [];
  }

  // First Dropdown compare filter: Values are between_clients and between_complexes
  comparisonTypeChanged(comparisonType: DropdownOption) {
    this.isBetweenComplexes = false;
    this.defaultAnalysisType = comparisonType.value;
    this.section.clientIds = [];
  }

  // Second Dropdown compare filter: Different values between section and Vaccination
  sectionTypeChanged(sectionType: DropdownOption) {
    if (sectionType.value === '') {
      this.isSectionTypeSelected = false;
    } else {
      this.isSectionTypeSelected = true;
      this.section.sectionType = sectionType.text;
      this.analysisStore.setSectionType(sectionType);
    }
  }

  // First Dropdown filter: List of Clients
  handleClientChanged(params: DropdownOption) {
    this.$refs.activeSelectedDropdown['isActive'] = true;
    this.section.clientIds = [];
    this.analysisStore.setClientName(params);
    this.section.clientIds.push(params.value);
  }

  // Second Dropdown filter: Values are Hatchery, Auditor and State
  handleCategoryTypeChanged(params: DropdownOption) {
    this.$refs.resetSelectedData['selectedData'] = [];
    this.clientDetailStore.setClientId(Number(this.section.clientIds.toString()));
    this.section.categoryType = params.value;
    if (params.value === 'auditor') {
      this.auditorDetailStore.fetchAuditorsDropdown(this.section.clientIds[0]);
    }
  }

  // Third Dropdown filter: Watch if there are changes (selected) in State, Hatchery and Auditor Dropdown
  // then call the respective API for data listing in dropdown filter
  @Watch('defaultFilterType')
  onChangeCategoryType() {
    if (this.section.categoryType === 'state') {
      return this.regionsName;
    }
    if (this.section.categoryType === 'auditor') {
      return this.auditorsName;
    }
  }

  changeBorder(){
    if (String(this.reportTypeDetailStore.reportTypeId) === ReportTypeIds.water) {
      return 'water';
    }
    if (String(this.reportTypeDetailStore.reportTypeId) === ReportTypeIds.injectable) {
      return 'injectable';
    }
    if (String(this.reportTypeDetailStore.reportTypeId) === ReportTypeIds.hatchery) {
      return 'hatchery';
    }
  }

  filterClientName(filteredData: []) {
    this.section.clientIds = [...filteredData];
  }

  onCloseClientNameDropdown(selectedData: []) {
    this.section.clientIds = [...selectedData];
  }

  filterCategoryName(filteredData: []) {
    this.section.filteredData = [...filteredData];
  }

  onCloseCategoryTypeDropdown(selectedData: []) {
    this.section.filteredData = [...selectedData];
  }

  // When generate button is clicked
  handleGenerateReport() {
    this.analysisStore.setAnalysisType(this.defaultAnalysisType);
    this.analysisStore.setStartDate(moment(this.section.fromMonth!).format('YYYY-MM'));
    this.analysisStore.setEndDate(moment(this.section.toMonth!).format('YYYY-MM'));
    this.analysisStore.setClientIds(this.section.clientIds);
    this.analysisStore.setReportTypeId(this.reportTypeDetailStore.reportTypeId);
    // TODO: Refactor
    if (this.section.categoryType === 'state') {
      this.analysisStore.setStates(this.section.filteredData);
    }
    if (this.section.categoryType === 'auditor') {
      this.analysisStore.setAuditors(this.section.filteredData);
    }
    //
    this.analysisStore.setCategoryType(this.section.categoryType);
    this.analysisStore.fetchAll();
  }

  get sections() {
    return this.analysisStore.hatchery;
  }

  @Watch('section')
  get dropdownIsValid(): boolean {
    const excludedKeys: string[] = [];

    // Push key that doesn't have in between clients to excludedkeys array
    if (this.defaultAnalysisType === 'between_clients') {
      excludedKeys.push('categoryType');
      excludedKeys.push('filteredData');
    }

    // Filter keys that have same value as in the result object, exclude it and put it in new array
    const keys = Object.keys(this.section).filter(
      (key) => excludedKeys.includes(key) === false,
    );

    // Check each keys whether got values or empty
    const values = keys.map((key) => {
      // if no values in array of clientIds or in filteredData return false
      if (
        (key === 'clientIds' && !this.section[key].length) ||
        (key === 'filteredData' && !this.section[key].length)
      ) {
        return false;
      }
      return this.section[key];
    });
    return values.every(Boolean);
  }
}
